import { h } from '@stencil/core';
import { SilverMedal, GoldMedal } from '../../../../icons';
import { MedalType } from '@ugc-components/ugc-pdp-review/interface';

export const medalsMap = new Map([
  [
    MedalType.Gold,
    {
      backgroundColor: '#ffea00',
      color: '#8a6702',
      icon: <GoldMedal />,
      hoverIcon: <GoldMedal width="20" height="20" />,
      hoverSvg: `<svg width="20" height="20" fill="none" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.25 0a1 1 0 0 1 1 1v.5H9a1 1 0 0 1 1 1V3a3.502 3.502 0 0 1-2.53 3.364A3.248 3.248 0 0 1 5.5 7.462V9H6c.527 0 1 .5.997 1H7 3c0-.5.448-1 1-1h.5V7.462a3.245 3.245 0 0 1-1.969-1.098A3.5 3.5 0 0 1 0 3v-.5a1 1 0 0 1 1-1h.75V1a1 1 0 0 1 1-1h4.5zm-5.5 2.5H1V3c0 .725.309 1.379.803 1.835a3.274 3.274 0 0 1-.053-.585V2.5zM9 2.5h-.75v1.75c0 .2-.018.395-.053.585a2.492 2.492 0 0 0 .8-1.727L9 3v-.5z"
          fill="#8A6702"
        />
      </svg>`,
    },
  ],
  [
    MedalType.Silver,
    {
      backgroundColor: '#e0e0e0',
      color: '#333',
      icon: <SilverMedal />,
      hoverIcon: <SilverMedal width="20" height="20" />,
      hoverSvg: `<svg width="20" height="20" fill="none" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.5 3.5a3.5 3.5 0 1 0-7 0 3.5 3.5 0 0 0 7 0zM2 9.733V6.646A3.99 3.99 0 0 0 5 8a3.99 3.99 0 0 0 3-1.354v3.087c0 .162-.127.233-.279.258a.497.497 0 0 1-.268-.043l-2.115-.882a.88.88 0 0 0-.676 0l-2.115.882a.497.497 0 0 1-.268.043C2.127 9.966 2 9.895 2 9.733z"
          fill='#666'
        />
      </svg>`,
    },
  ],
]);
